module.exports = __webpack_public_path__ + "static/img/news-img2.509296f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news-img2.png
// module id = elph
// module chunks = 3